import VideoEventBus from './VideoEventBus';

/**
 * Extend VideoEventBus and enhance handling to support additional canvas operations.
 *
 */
class CanvasVideoEventBus extends VideoEventBus {
    constructor ({ video, stream, syncController, setStreamError, setIsLoading, setAutoPlayError, frameDrawer }) {
        super({ video, stream, syncController, setStreamError, setIsLoading, setAutoPlayError });
        this.frameDrawer = frameDrawer;
    }

    handleLoaded () {
        const frameDrawer = this.frameDrawer.current;

        if (frameDrawer) {
            frameDrawer.schedule();
        }

        super.handleLoaded();
    }

    destroy () {
        super.destroy();
        this.frameDrawer = null;
    }
}

export default CanvasVideoEventBus;
